import React, { useState } from "react";
import "./Navbar.css";

function Navbar() {
  // State to manage whether the mobile menu is open or not
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Function to toggle the menu state
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to close the menu (used by links and the overlay)
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          {/* Navigation Links - class changes based on state */}
          <div className={isMenuOpen ? "nav-links open" : "nav-links"}>
            <a href="#home" onClick={closeMenu}>
              Home
            </a>
            <a href="#skills" onClick={closeMenu}>
              Skills
            </a>
            <a href="#about" onClick={closeMenu}>
              About
            </a>
            <a href="#work-history" onClick={closeMenu}>
              Work History
            </a>
            <a href="#replikit" onClick={closeMenu}>
              Replikit
            </a>
            <a href="#projects" onClick={closeMenu}>
              Projects
            </a>
            <a href="#education" onClick={closeMenu}>
              Education
            </a>
            <a href="#volunteering" onClick={closeMenu}>
              Volunteering
            </a>
            <a href="#contact" onClick={closeMenu}>
              Contact
            </a>
          </div>
        </div>

        {/* Hamburger Menu Button - only visible on mobile */}
        <button className="menu-toggle" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </nav>
      {/* Overlay - appears when the menu is open to dim the background */}
      {isMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
    </>
  );
}

export default Navbar;
